import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
export const ProjectNode = memo(({ data, selected }) => {
    const nodeData = data;
    const metadata = nodeData.metadata;
    return (_jsxs("div", { className: `flow-node-project ${selected ? "selected" : ""}`, style: {
            padding: "12px",
            border: `1px solid ${selected ? "var(--flow-node-text, #000)" : "var(--flow-node-border, #e5e5e5)"}`,
            borderRadius: "6px",
            background: "var(--flow-node-bg, #fff)",
            minWidth: "160px",
        }, children: [_jsx(Handle, { type: "target", position: Position.Top, style: { background: "var(--flow-node-border, #e5e5e5)" } }), _jsxs("div", { children: [_jsx("div", { style: {
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "var(--flow-node-text, #000)",
                            marginBottom: "6px",
                        }, children: metadata.name }), _jsxs("div", { style: {
                            fontSize: "12px",
                            color: "var(--flow-node-text-secondary, #444)",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexWrap: "wrap",
                        }, children: [_jsx("span", { style: {
                                    padding: "2px 6px",
                                    borderRadius: "3px",
                                    border: "1px solid var(--flow-node-border, #e5e5e5)",
                                    fontSize: "11px",
                                    fontWeight: 500,
                                }, children: metadata.status }), metadata.taskCount !== undefined && (_jsxs("span", { style: { fontSize: "11px" }, children: [metadata.taskCount, " tasks"] }))] })] }), _jsx(Handle, { type: "source", position: Position.Bottom, style: { background: "var(--flow-node-border, #e5e5e5)" } })] }));
});
ProjectNode.displayName = "ProjectNode";
